import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

@Component({
  standalone: true,
  selector: 'app-toasts',
  templateUrl: `toasts.component.html`
})
export class ToastComponent implements OnInit {
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer: ToastContainerDirective | undefined;

  constructor(private readonly toastrService: ToastrService) { }
  ngOnInit() {
    this.toastrService.overlayContainer = this.toastContainer;
  }

  onClick() {
    this.toastrService.success('in div');
  }

  onRemove(toastId: number) {
    this.toastrService.remove(toastId);
  }
}
